import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rft-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.scss']
})
export class ProfileDetailsComponent implements OnInit {
 
  constructor() { }

  ngOnInit(): void {
  }
}
